"use client"
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useMemo,
  useState,
} from "react";
import { PreferredLanguage } from "../enums";
import English from "../dictionary/EnglishLanguage.json";
import Hindi from "../dictionary/HindiLanguage.json";
import French from "../dictionary/FrenchLanguage.json";
import German from "../dictionary/GermanLanguage.json";
import Spanish from "../dictionary/SpanishLanguage.json";
import Arabic from "../dictionary/ArabicLanguage.json";
import Italian from "../dictionary/ItalianLanguage.json";
import { PreferredLanguageType } from "../../types/interfaces";

type Dictionary = Record<string, string>;

const dictionaries: Record<PreferredLanguage, Dictionary> = {
  [PreferredLanguage.English]: English as Dictionary,
  [PreferredLanguage.Hindi]: Hindi as Dictionary,
  [PreferredLanguage.French]: French as Dictionary,
  [PreferredLanguage.German]: German as Dictionary,
  [PreferredLanguage.Spanish]: Spanish as Dictionary,
  [PreferredLanguage.Arabic]: Arabic as Dictionary,
  [PreferredLanguage.Italian]: Italian as Dictionary,
};

interface ILanguageContext {
  preferredLanguage: PreferredLanguageType;
  setPreferredLanguage: Dispatch<SetStateAction<PreferredLanguageType>>;
  translate: (text: string) => string;
}

export const LanguageContext = createContext<ILanguageContext | undefined>(
  undefined
);

export default function LanguageContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [preferredLanguage, setPreferredLanguage] =
    useState<PreferredLanguageType>(PreferredLanguage.English);

  const translate = (text: string): string => {
    return dictionaries?.[preferredLanguage]?.[text] ?? text;
  };

  const value = useMemo(
    () => ({
      preferredLanguage,
      setPreferredLanguage,
      translate,
    }),
    [preferredLanguage]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}
